/* unplugin-vue-components disabled */import script from "./log.vue?vue&type=script&setup=true&lang=ts"
export * from "./log.vue?vue&type=script&setup=true&lang=ts"

import "./log.vue?vue&type=style&index=0&id=c4619fc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4619fc6"]])

export default __exports__